// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReturnedCheckDetailsAllOfProcessingDecision } from './IReturnedCheckDetailsAllOfProcessingDecision';
import {
    IReturnedCheckDetailsAllOfProcessingDecisionFromJSON,
    IReturnedCheckDetailsAllOfProcessingDecisionFromJSONTyped,
    IReturnedCheckDetailsAllOfProcessingDecisionToJSON,
    IReturnedCheckDetailsAllOfProcessingDecisionToJSONTyped,
} from './IReturnedCheckDetailsAllOfProcessingDecision';

/**
 * 
 * @export
 * @interface IReturnedCheckDecisionDto
 */
export interface IReturnedCheckDecisionDto {
    /**
     * 
     * @type {number}
     * @memberof IReturnedCheckDecisionDto
     */
    lockbox_id: number;
    /**
     * 
     * @type {IReturnedCheckDetailsAllOfProcessingDecision}
     * @memberof IReturnedCheckDecisionDto
     */
    processing_decision: IReturnedCheckDetailsAllOfProcessingDecision;
}

/**
 * Check if a given object implements the IReturnedCheckDecisionDto interface.
 */
export function instanceOfIReturnedCheckDecisionDto(value: object): value is IReturnedCheckDecisionDto {
    if (!('lockbox_id' in value) || value['lockbox_id'] === undefined) return false;
    if (!('processing_decision' in value) || value['processing_decision'] === undefined) return false;
    return true;
}

export function IReturnedCheckDecisionDtoFromJSON(json: any): IReturnedCheckDecisionDto {
    return IReturnedCheckDecisionDtoFromJSONTyped(json, false);
}

export function IReturnedCheckDecisionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReturnedCheckDecisionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lockbox_id': json['lockbox_id'],
        'processing_decision': IReturnedCheckDetailsAllOfProcessingDecisionFromJSON(json['processing_decision']),
    };
}

export function IReturnedCheckDecisionDtoToJSON(json: any): IReturnedCheckDecisionDto {
    return IReturnedCheckDecisionDtoToJSONTyped(json, false);
}

export function IReturnedCheckDecisionDtoToJSONTyped(value?: IReturnedCheckDecisionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lockbox_id': value['lockbox_id'],
        'processing_decision': IReturnedCheckDetailsAllOfProcessingDecisionToJSON(value['processing_decision']),
    };
}

